import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import Waypoint from 'react-waypoint';

import {
  productThumbnailClickCrossSell as trackProductThumbnailClickCrossSell,
  productThumbnailImpressionCrossSell as trackProductThumbnailImpressionCrossSell,
} from 'analytics/product';
import { constructPagePath } from 'utils/localeRouteGuide';

import localize from 'components/Localize/Localize';
import { ResponsiveImage } from 'sheets';

import translations from './translations';
import styles from './CrossSell.css';

const cx = classNames.bind(styles);

class CrossSell extends React.Component {
  constructor() {
    super();

    this.state = {
      visibleProducts: {},
      hoveredProduct: null,
      productImpressionFired: {},
    };
  }

  componentDidMount() {
    if (!this.props.t) {
      return;
    }

    this.props.t.products.map((item) => {
      this.setState((state) => ({
        productImpressionFired: {
          ...state.productImpressionFired,
          [item.heading]: false,
        },
      }));
    });
  }

  toggleShowImage(key, isToggled) {
    this.setState((state) => ({
      ...state,
      visibleProducts: {
        ...state.visibleProducts,
        [key]: isToggled,
      },
    }));
  }

  toggleHoverImage(key, isToggled) {
    this.setState({
      hoveredProduct: isToggled ? key : null,
    });
  }

  renderProductImage(product, imgClass) {
    const imageConfig = [
      {
        path: product.mobileImagePath,
        media: `(max-width: 767px)`,
        sizes: `120vw`,
        min: 384,
        max: 920,
      },
      {
        path: product.imagePath,
        media: `(min-width: 768px)`,
        sizes: `1000px`,
        min: 1000,
      },
    ];

    return (
      <ResponsiveImage
        className={imgClass}
        config={imageConfig}
        description={product.imageAlt}
      />
    );
  }

  renderProductRow(product, index) {
    const imgClass = cx(`image`, `image--${index + 1}`, {
      'image--visible': this.state.visibleProducts[index],
      'image--hovered': this.state.hoveredProduct === index,
    });

    const pdpLink = constructPagePath(this.props.locale, product.pdpPath);

    return (
      <div
        className={styles[`row`]}
        key={index}
        onBlur={this.toggleHoverImage.bind(this, index, false)}
        onFocus={this.toggleHoverImage.bind(this, index, true)}
        onMouseOut={this.toggleHoverImage.bind(this, index, false)}
        onMouseOver={this.toggleHoverImage.bind(this, index, true)}
      >
        <div className={styles[`copy-container-wrapper`]}>
          <div className={styles[`copy-container`]}>
            <h5 className={styles[`row-heading`]}>
              {product.heading}
            </h5>
            <p className={styles[`copy`]}>
              {product.copy}
            </p>
            <a
              className={styles[`product-link`]}
              href={pdpLink}
              onClick={trackProductThumbnailClickCrossSell.bind(this, product.analytics.category, index)}
            >
              {product.productLinkCta}
            </a>
          </div>
        </div>
        <div className={styles[`image-container`]}>
          <Waypoint
            bottomOffset={50}
            fireOnRapidScroll={true}
            onEnter={this.toggleShowImage.bind(this, index, true)}
          />
          <Waypoint onEnter={this.analyticsProductImpression.bind(this, product, index)} />
          {this.renderProductImage(product, imgClass)}
        </div>
      </div>
    );
  }

  analyticsProductImpression(product, index) {
    if (this.state.productImpressionFired[product.heading]) {
      return;
    }

    trackProductThumbnailImpressionCrossSell(product.analytics.category, index);
    this.state.productImpressionFired[product.heading] = true;
  }

  renderProductRows(products) {
    return products.map((product, idx) => this.renderProductRow(product, idx));
  }

  render() {
    if (!this.props.t) {
      return null;
    }

    return (
      <section className={styles[`container`]}>
        <div className={styles[`content`]}>
          <h2 className={styles[`heading`]}>{this.props.t.heading}</h2>
          <div className={styles[`products`]}>
            {this.renderProductRows(this.props.t.products)}
          </div>
        </div>
      </section>
    );
  }
}

CrossSell.propTypes = {
  t: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string.isRequired,
        copy: PropTypes.string.isRequired,
        pdpPath: PropTypes.string.isRequired,
        productLinkCta: PropTypes.string.isRequired,
        imagePath: PropTypes.string.isRequired,
        imageAlt: PropTypes.string.isRequired,
      })
    ),
  }),
};

export default localize(CrossSell, translations, false);
